/* unplugin-vue-components disabled */import script from "./webheader.vue?vue&type=script&lang=ts&setup=true"
export * from "./webheader.vue?vue&type=script&lang=ts&setup=true"

import "./webheader.vue?vue&type=style&index=0&id=fdfae3cc&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdfae3cc"]])

export default __exports__